export default function isComposeMode(): boolean {
  return typeof Office.context.mailbox?.item?.to?.addAsync === 'function';
}
